<template>
  <div class="form_item">
    <div>
      <Label :required="required" :label="label" :for_id="save_to"/>
      <div class="upload-btn-wrapper">
        <button class="upload-btn" type="button"  v-html="buttonUploadLabel" v-if="isButtonUpload"></button>
        <input
          v-validate="rules"
          :id="save_to"
          type="file"
          :name="validationLabel || label"
          :key="save_to"
          :ref="save_to"
          v-on:change="handleFileUpload()"
          :required="required"
          :autocomplete="autocomplete"
          :class="{'has-error': errors.has(label)}"
          :accept="accept"
        />
      </div>
      <span class="upload-btn-set" v-if="isButtonUpload && $refs[save_to] && $refs[save_to].files && $refs[save_to].files[0]">{{$refs[save_to].files[0].name}}</span>
    </div>
    <p v-if="info !== undefined" class="info" v-html="info"></p>
    <span class="warning" v-if="blurry && !disableBlurCheck && locale == 'fr'">⚠️ {{$t('blurry_document', locale)}}</span>
    <span class="error" v-show="errors.has(validationLabel || label)">{{ errors.first(validationLabel || label) }}</span>
  </div>
</template>

<script>
import { validatorComponent } from './validatorComponentMixin';
import init, { variance_of_laplacian } from "../rust_blur_lib/blur";
import i18n from './i18n';

export default {
  name: 'Input',
  mixins: [validatorComponent, i18n.mixin],
  props: {
    save_to: String,
    type: String,
    isButtonUpload: Boolean,
    buttonUploadLabel: String,
    validationLabel: String,
    locale: {
      type: String,
      default: 'fr'
    },
    disableBlurCheck: Boolean,
    sizeMax: {
      type: Number,
      default: 2560
    },
    accept: {
      type: String,
      //required: true
    },
    required: Boolean,
    validationRules: [String, Object],
    autocomplete: String,
    inputmode: {
      type: String,
      default: 'text'
    },
    pattern: String
  },
  data: function() {
    return {
      blurry: false,
    }
  },
  computed: {
    rules () {
      if(this.require) {
        return 'required|size:' + this.sizeMax;
      }
      return 'size:' + this.sizeMax;
    }
  },
  methods: {
    handleFileUpload () {
      this.blurry = false;
      const file = this.$refs[this.save_to].files[0];
      if (file !== 'undefined') {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = async () => {
          this.val = reader.result;
          if (reader.result.indexOf('data:application/pdf') !== 0) {
            this.test(reader.result);
          }
        };
      }
    },
    async test(fileReaderResult) {
      console.log("test blur");
      const canvas = document.createElement('canvas');
      const img = new Image();
      img.src = fileReaderResult;
      await new Promise(function (resolve) {
        img.onload = resolve;
      });
      const ctx = canvas.getContext('2d');
      let w = img.width, h = img.height;
      canvas.height = h;
      canvas.width = w;
      ctx.drawImage(img, 0, 0, w, h);
      await init();
      const imageData = ctx.getImageData(0, 0, w, h);
      const blurIndex = await variance_of_laplacian(imageData.data, w, h);
      console.log("test blur done blurIndex:", blurIndex);

      if(blurIndex < 130) {
        this.blurry = true;
      }
    },
  }
};
</script>
